import { render, staticRenderFns } from "./xunta_mimi.vue?vue&type=template&id=779a894f&scoped=true&"
import script from "./xunta_mimi.vue?vue&type=script&lang=js&"
export * from "./xunta_mimi.vue?vue&type=script&lang=js&"
import style0 from "./xunta_mimi.vue?vue&type=style&index=0&id=779a894f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779a894f",
  null
  
)

export default component.exports